import { css } from '@microsoft/fast-element';
import { accordionItemStyles } from '../accordion-item/accordion-item.styles';

export const accordionAnchorStyles = css`
    ${accordionItemStyles}

    .button {
        text-decoration: none;
        margin: 0em;
        display: flex;
        align-items: center;
    }
`;
